import { render, staticRenderFns } from "./ModuleSwipe.vue?vue&type=template&id=3083fc3e&scoped=true"
import script from "./ModuleSwipe.vue?vue&type=script&lang=js"
export * from "./ModuleSwipe.vue?vue&type=script&lang=js"
import style0 from "./ModuleSwipe.vue?vue&type=style&index=0&id=3083fc3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3083fc3e",
  null
  
)

export default component.exports